<!-- 获取授权商数据接收情况接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "parkCode":"2KKN885S",
                "dataType":6,
                "startTime":"20180703000000",
                "endTime":"20180703235959"
            },
            responseCode: {"data":
                                {
                            "total":100,
                            "successTotal": 80
                        },"message":"业务成功","resultCode":0,"status":1},
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台获取授权商数据接收情况",
                t_url: this.commonUrls.test+"getDataReception",
                p_url: this.commonUrls.prod+"getDataReception",
                precondition: "无",
                fitSystem: "VEMS传统停车场, 云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '否', info3: 'String', info4: '停车场编号' },
                        { info1: 'dataType', info2: '否', info3: 'Integer', info4: '数据类型 0-reportCarIn(进场上报)、1-reportCarOut出场上报、、2-reportParkBill（账单上报）、3-reportMonthCar（月卡开通续费上报）、4reportAbnormalCar（遥控开闸上报）、5-reportModifyCar（校正车牌上报）、6-reportParkingFee（临停交费上报）、7-reportCarPicture（图片信息上报）、8-reportTicketUseRecord（储值卡扣费流水上报）、9-reportCarOwner（车主信息上报）、10-reportCar（车辆信息上报）、11-reportEquipmentStatus（设备状态信息上报）、12-reportShift（交接班信息上报）、13-reportCarport（车位信息上报）、14-reportPreCarIn（预进场上报）、15-reportPreCarOut（预出场上报）、16-getUserCredits（第三方提供获取用户积分）、17-reduceUserCredits（第三方抵扣积分扣减接口）、18-reverseUserCredits（第三方提供积分冲正接口）、19-reportParkHeartbeat（车场心跳）、20-notifyPayInfo（支付通知接口）、21-reportBlacklistRecord（黑名单上报）' },
                        { info1: 'startTime', info2: '是', info3: 'String', info4: '时间段开始时间, yyyyMMddHHmmss（时间段间隔不能超过1天，建议从当天00:00:00到23:59:59进行请求）' },
                        { info1: 'endTime', info2: '是', info3: 'String', info4: '时间段开始时间, yyyyMMddHHmmss（时间段间隔不能超过1天，建议从当天00:00:00到23:59:59进行请求）' },
                    ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'total', info2: '是', info3: 'Integer', info4: '数据总量' },
                        { info1: 'successTotal', info2: '是', info3: 'String', info4: '数据总量（成功发送）' },
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/upward/getDataReception.vue